import {
    GET_MERCHANT_TRANSACTION_COUNT_FAILED,
    GET_MERCHANT_TRANSACTION_COUNT_SUCCESS,
    GET_MERCHANT_TRANSACTION_COUNT_LOADING,
    REMOVE_MERCHANT_TRANSACTION_COUNT,
} from "../types";


const initialState = {
    lastTransactionCount: null,
    loading: null,
    error: null,
};

export const getMerchantTransactionCountReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_TRANSACTION_COUNT_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_TRANSACTION_COUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                lastTransactionCount: action.payload,
            };
        case GET_MERCHANT_TRANSACTION_COUNT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_TRANSACTION_COUNT:
            return initialState;

        default:
            return state;
    }
};
